import { DecimalPipe, registerLocaleData } from '@angular/common';
import { provideHttpClient, withFetch } from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  Injectable,
  LOCALE_ID,
  provideAppInitializer,
  provideZoneChangeDetection
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { HammerGestureConfig, HammerModule, provideClientHydration, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideRouter, withRouterConfig } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { SsrCookieService } from 'ngx-cookie-service-ssr';
import { routes } from './app.routes';
import { AppServices } from './shared/services';
import { ClientStylesService } from './shared/services/client-styles/client-styles.service';
import { ClientService } from './shared/services/client/client.service';
import { TranslateService } from './shared/services/translation/translate.service';
import { WINDOW_PROVIDERS } from './shared/services/window/window.service';
registerLocaleData(localeFr);


@Injectable()
export class CustomHammerConfig extends HammerGestureConfig {
  override overrides = {
    swipe: { direction: 31 }, // Enable all swipe directions
    pinch: { enable: true }, // Enable pinch gestures
    rotate: { enable: false }, // Disable rotate
  };

  override options = {
    touchAction: 'pan-y', // ✅ Allow native vertical scrolling
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom([
      BrowserAnimationsModule,
      AppServices,
      AngularSvgIconModule.forRoot(),
      HammerModule,
    ]),
    DecimalPipe,
    Title,
    SsrCookieService,
    ClientStylesService,
    {
      provide: MatDialogRef,
      useValue: {},
    },
    provideAppInitializer(() => {
      const a = inject(ClientService);
      return a.load();
    }),
    provideAppInitializer(() => {
      const a = inject(TranslateService);
      return a.load();
    }),
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    WINDOW_PROVIDERS,
    provideHttpClient(withFetch()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withRouterConfig({
        onSameUrlNavigation: 'reload',
    })),
    provideClientHydration(),
    {
      provide: HammerGestureConfig,
      useClass: CustomHammerConfig,
    },
  ],
};
